import { Button, Modal } from "@/components";
import styles from "./DeleteAccountModal.module.scss";

type DeleteAccountModalProps = {
  isOpen: boolean;
  displayName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const DeleteAccountModal = ({
  isOpen,
  displayName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteAccountModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={isDeleting ? () => {} : onClose}>
      <div className={styles["comp"]}>
        <div>
          <div className={styles["comp__heading"]}>Delete account?</div>
          <p className={styles["comp__description"]}>
            This permanently removes the user, cancels subscriptions in Stripe, and cannot be undone.
          </p>
          <div className={styles["comp__label"]} title={displayName}>
            {displayName}
          </div>
        </div>

        <div className={styles["comp__actions"]}>
          <Button type="button" variant="secondary" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
